import React,{useState,useEffect,useRef } from "react";
import {Link} from 'react-router-dom'
import { Container, Row, Button, Col, Input } from "reactstrap";
import Header from 'components/Headers/Header';
import QRReader from "./QRReader";
import { getOrder, finalPay } from "network/ApiAxiosTickets";
import OrderItem from "./OrderItem";
import DepositCard from './DepositCard'
import { Spinner } from "reactstrap";
import EditOrders from "./EditOrders";

const TicketShop = () => {
const [orderID, setOrderID] = useState("");
const [order, setOrder] = useState();
const [confirmation, setConfirmation] = useState(false);
const [deposits, setDeposits] = useState(false);
const [camera, setCamera] = useState(false);
const [inputOrderID, setInputOrderID] = useState("");
const [redAlert, setRedAlert] = useState(false);
const [spinner, setSpinner] = useState(false);
const [inputHide, setInputHide] = useState(true);
const [links, setLinks] = useState([]);

const inputReference = useRef(null);

const role = JSON.parse(localStorage.getItem('user')).role
console.log(role)

useEffect(() => {
  orderCall(orderID)
}, [orderID]);

useEffect(() => {
  focusInput()
}, []);

const focusInput =() => inputReference.current.focus();

const orderCall = async(v)=>{
  setRedAlert(false)
  setCamera(false)
  setSpinner(true)
  setLinks([])
  if(v){
      const response = await getOrder(v)
      if(response.data.success==false){
        setRedAlert(true)
        setSpinner(false)
        inputReference.current.value=""
        focusInput()
      }else{
        setOrder(response.data)
        setConfirmation(false)
        setSpinner(false)
        inputReference.current.value=""
        focusInput()
      }
      
    }else{
      setSpinner(false)
      focusInput()
    } 
}

const handlePay = async ()=>{
  setSpinner(true)
  console.log(orderID)
  const response = await finalPay(orderID,order.total)
  if(response.data.success){
    setInputOrderID("")
    setOrder()
    setConfirmation(true)
    setOrderID()
    setCamera(false)
    focusInput()
    if(response.data.links){
      setLinks(response.data.links)
    }
    setSpinner(false)
  }
}

const handleTextInput = (e)=>{
    setSpinner(true)
    setTimeout(() => {
    setRedAlert(false)
    setInputOrderID(e)
    orderCall(e)
    // Send Axios request here
  }, 3000)
}

const displayLinks = ()=>{
  if(links.length>0){
    return links.map((link)=>{
      return <div className="bg-red w-100 h-100" key={link}>
        <a href={link}>Choose Table</a>
      </div>
    })
  }
}
    
    return (
      <>
        {role == 'admin' && <Header/>}
        <Container  fluid>
          
          <div className="row mb-6" ></div>

          <Button onClick={()=>{setCamera(!camera);setDeposits(false);setOrder();focusInput()}} className="float-left text-left">
          <i className= {camera?"ni ni-camera-compact text-red mr-1":"ni ni-camera-compact text-blue mr-1"}  /> Scan  
          </Button>
        
          <Button onClick={()=>{setInputHide(!inputHide);setDeposits(!deposits);setCamera(false);setOrder()}} className="float-right text-right">
            <i className='ni ni-money-coins text-blue mr-1'  /> Deposits 
          </Button>
            
          <div className="row mb-6" ></div>
          
          {inputHide && 
          <Row className="text-center justify-content-center">
            <Input type="text" innerRef={inputReference} placeholder="Input the order ID" onChange={(e)=>handleTextInput(e.target.value)} style={{width:"50%"}} className={redAlert ? "bg-red" : ""} />
            {spinner &&
            <Spinner size="">
              Loading...
            </Spinner>}
          </Row>
          }
          {confirmation &&
          <Row>
            <span className=" bg-green">Payment done</span>
          </Row>
          }
          <Row className="justify-content-center" >
            <div style={{height:"50%",width:"50%"}}>
              {camera?<QRReader order={setOrderID}/>
              :null
            }
            </div>
          </Row>
          {order?
            <>
            {order.Collected ? 
              <h3 className="float-right">Paid</h3>
              :<Button className="float-right btn-default" onClick={handlePay} >
                <i className='ni ni-credit-card text-white mr-1' /> 
                Pay 
              </Button>
              }
              <div className='text-center'>
                <h2>Name: {order.clientName}</h2>
                
              </div>  
              {order.cart.map((item)=>{
                return (<OrderItem key={item._id} item={item} />)
              })}
            </>
          :null}
          {/*displayLinks()*/}
          
          {deposits?
          <DepositCard/>
          : null}
        </Container>
      </>
    );
}

export default TicketShop;
